export enum PayType {
  ANNUAL_PACKAGE = 'annualSalary',
  ANNUAL_COMMISSION = 'annualCommission',
  COMMISSION_ONLY = 'commissionOnly',
  HOURLY_RATE = 'hourlyRate',
  MONTHLY = 'monthly',
}

export type SalaryType = 'ANNUAL' | 'MONTHLY' | 'HOURLY';

export type SuggestedSalary = {
  min: number;
  max: number;
  averageMin: number;
  averageMax: number;
  location: string;
  roleTitle: string;
  currency: string;
};
